import { Expose } from 'class-transformer';
import { SurveyElementsUnion } from '@/models//survey-elements-union';

export class GroupingElement {
  @Expose()
  elements!: SurveyElementsUnion[];

  @Expose()
  outlined?: boolean;
}
